import { Badge } from "antd";
import clsx from "clsx";
import React, { useState } from "react";
import s from "./UserDetails.module.scss";
import Profile from "../../Profile";
import Groups from "../../Groups";
import Messages from "../../Messages";
import TabsTemplate from "../../../../../../../global components/TabsTemplate/TabsTemplte";
import { useQuery } from "../../../../../../../libs/common";
import { UseAuthToken } from "../../../../../../../libs/api/userSession";
import useSWR from "swr";
import { swrFetcher } from "../../../../../../../libs/api/Endpoints";
import { PaginatedSentMessage } from "../../../../../../../libs/Utils/Types/Message";
function UserDetails() {
  const query = useQuery();
  const userId = query.get("userId");
  const token = UseAuthToken();
  const {
    data: groups,
   
  } = useSWR<{ name: string }[], any, any>(
    token ? [`api/admin/users/${userId}/contact-groups`, token] : null,
    swrFetcher,

    {
      revalidateOnFocus: true, // Refetch when the window regains focus
      // Refetch every 10 seconds (10000 ms)
      shouldRetryOnError: false, // Disable retrying on errors
    }
  );
  const {
    data: userMessages,
    
  } = useSWR<PaginatedSentMessage, any, any>(
    token
      ? [
          `api/admin/users/${userId}/messages`,
          token,
          
        ]
      : null,
    swrFetcher,
    {
      revalidateOnFocus: true, // Refetch when the window regains focus
      // Refetch every 10 seconds (10000 ms)
      shouldRetryOnError: false, // Disable retrying on errors
    }
  );
  const [activeTabKey, setActiveTabKey] = useState("1");
  const productTabs = [
    {
      key: "1",
      label: (
        <>
          <Badge
            offset={[5, 12]}
            //count={TableContacts?.totalDocs}
            color={activeTabKey === "1" ? "#d52b1e" : "#F0F2F5"}
            className={clsx({ [s.activeBadge]: activeTabKey === "1" })} // Use clsx for conditional class
          >
            <h2>Profile</h2>
          </Badge>
        </>
      ),
      children: <Profile />,
    },
    {
      key: "2",
      label: (
        <>
          <Badge
            offset={[6, 12]}
            count={groups?.length}
            style={{marginRight:"-5px"}}

            color={activeTabKey === "2" ? "#d52b1e" : "#F0F2F5"}
            className={clsx({ [s.activeBadge]: activeTabKey === "2" })} // Use clsx for conditional class
          >
            <h2>Groups</h2>
          </Badge>
        </>
      ),
      children: <Groups />,
    },
    {
      key: "3",
      label: (
        <>
          <Badge
            offset={[6, 12]}
            count={userMessages?.pagination.totalItems}
            style={{marginRight:"-5px"}}
            color={activeTabKey === "3" ? "#d52b1e" : "#F0F2F5"}
            className={clsx({ [s.activeBadge]: activeTabKey === "3" })} // Use clsx for conditional class
          >
            <h2>Messages</h2>
          </Badge>
        </>
      ),
      children: <Messages />,
    },
  ];
  const handleTabChange = (key: string) => {
    setActiveTabKey(key); // Update the active tab key
  };
  return (
    <div className={s.wrapper}>
      <TabsTemplate
        tabItems={productTabs}
        wrapperClassname={s.customClass}
        onTabChange={handleTabChange} // Pass the tab change handler
        withBorderBottom={true}
      />
    </div>
  );
}

export default UserDetails;
